import { render, staticRenderFns } from "./ReportBlockFooter.vue?vue&type=template&id=801ade08&scoped=true"
import script from "./ReportBlockFooter.vue?vue&type=script&lang=js"
export * from "./ReportBlockFooter.vue?vue&type=script&lang=js"
import style0 from "./ReportBlockFooter.vue?vue&type=style&index=0&id=801ade08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801ade08",
  null
  
)

export default component.exports